module.exports = __webpack_public_path__ + "static/media/0300_Small.5ae38349.jpg";